<script setup lang="ts">
import { Sparkles, X } from 'lucide-vue-next';
import { ref, onMounted } from 'vue';

const FEEDBACK_WIDGET_CLOSED_TIMESTAMP_KEY = 'feedbackWidgetClosedTimestamp';
const SEVEN_DAYS_IN_MS = 7 * 24 * 60 * 60 * 1000;

const showWidget = ref(true);

onMounted(() => {
  const closedTimestamp = localStorage.getItem(FEEDBACK_WIDGET_CLOSED_TIMESTAMP_KEY);
  if (closedTimestamp) {
    if (Date.now() - parseInt(closedTimestamp, 10) < SEVEN_DAYS_IN_MS) {
      showWidget.value = false;
    } else {
      // If 7 days have passed, remove the old timestamp so it shows again until next close
      localStorage.removeItem(FEEDBACK_WIDGET_CLOSED_TIMESTAMP_KEY);
    }
  }
});

const closeWidget = () => {
  localStorage.setItem(FEEDBACK_WIDGET_CLOSED_TIMESTAMP_KEY, Date.now().toString());
  showWidget.value = false;
};
</script>

<template>
  <div
    v-if="showWidget"
    class="fixed right-[-53px] top-1/2 z-50 flex -translate-y-1/2 -rotate-90 transform gap-2 rounded-t-md bg-emerald-600 py-2 pl-3 pr-2 text-white"
  >
    <NuxtLink
      to="https://mintgarden.featurebase.app"
      target="_blank"
      class="flex transform cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-semibold no-underline"
    >
      <Sparkles class="h-4 w-4" />
      Feedback
    </NuxtLink>
    <div class="flex items-center justify-center">
      <button
        aria-label="Close feedback widget"
        class="cursor-pointer rounded-full bg-emerald-700 p-1"
        @click="closeWidget"
      >
        <X class="h-3 w-3" />
      </button>
    </div>
  </div>
</template>
